<template>
  <v-card class="emp-details" v-if="emp">
    <v-card-title>
      <img :src="emp.img || require('@/assets/imgs/no-img21.png')" />
      <v-row class="flex-column ml-3">
        <span class="d-flex justify-space-between">
          <span class="headline-1">{{ emp.name }}</span>
          <span class="headline-4">{{ emp.cId }}</span>
        </span>
        <span class="headline-2">{{ emp.department }}</span>
        <span class="headline-3">{{ emp.post }}</span>
        <span class="headline-4">{{ emp.farm }}</span>
      </v-row>
    </v-card-title>
    <v-card-text class="pb-0">
      <v-row v-if="emp.address">
        <v-col cols="6" sm="2" class="font-weight-bold">
          <span>Direccion</span>
        </v-col>
        <v-col class="px-0">
          <span>{{ emp.address }}</span>
        </v-col>
        <v-col cols="6" sm="2" class="px-3 px-sm-0 font-weight-bold">
          <span>DPI</span>
        </v-col>
        <v-col class="px-0">
          <span>{{ emp.dpi }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" sm="2" class="font-weight-bold">
          <span>Telephono</span>
        </v-col>
        <v-col class="px-0">
          <span>{{ emp.phone }}</span>
        </v-col>
        <v-col cols="6" sm="2" class="px-3 px-sm-0 font-weight-bold">
          <span>Cuenta Bancaria</span>
        </v-col>
        <v-col class="px-0">
          <span>{{ emp.bankAcc }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" sm="3" class="font-weight-bold">
          <span>Salud</span>
        </v-col>
        <v-col cols="6" sm="3">
          <span>{{ emp.health ? "Si" : "No" }}</span>
        </v-col>
        <v-col cols="6" sm="3" class="font-weight-bold px-0">
          <span>Fecha de Nacimiento</span>
        </v-col>
        <v-col cols="6" sm="3">
          <span>{{ emp.birth ? new Date(emp.birth).toLocaleDateString("es-GU") : 'Faltante' }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" sm="3" class="py-0 font-weight-bold">Fecha de Ingreso</v-col>
        <v-col cols="6" sm="3" class="py-0 px-0">{{
          emp.entry ? new Date(emp.entry).toLocaleDateString("es-GU") : "No"
        }}</v-col>
        <v-col cols="6" sm="3" class="py-0 px-3 px-sm-0 font-weight-bold">Fecha de Baja</v-col>
        <v-col cols="6" sm="3" class="py-0 px-0">{{
          emp.exit ? new Date(emp.exit).toLocaleDateString("es-GU") : "No"
        }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" class="font-weight-bold">
          <span>Comentarios</span>
        </v-col>
        <v-col cols="12" sm="12" class="py-0 pb-2">
          <span>{{ emp.comment || "Faltante" }}</span>
        </v-col>
      </v-row>
      <v-divider class="my-5"></v-divider>
      <v-row>
        <v-col cols="6" sm="6" class="pb-0 font-weight-bold">Salario Nomina</v-col>
        <v-col cols="6" sm="6" class="px-0 pb-0 font-weight-bold">Salario Ayco</v-col>
      </v-row>
      <v-row>
        <v-col cols="3" sm="3" class="pb-0 font-weight-medium">
          <span>Diario</span>
        </v-col>
        <v-col cols="3" sm="3" class="pb-0 px-0">
          <span>{{ formatMoney(emp.salaryNomina) }}</span>
        </v-col>
        <v-col cols="3" sm="3" class="pb-0 px-0 font-weight-medium">
          <span>Diario</span>
        </v-col>
        <v-col cols="3" sm="3" class="pb-0 px-0">
          <span>{{ formatMoney(emp.salaryAyco) }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" sm="3" class="font-weight-medium">
          <span>Hora Extra</span>
        </v-col>
        <v-col cols="3" sm="3" class="px-0">
          <span>{{ formatMoney(emp.hourNomina) }}</span>
        </v-col>
        <v-col cols="3" sm="3" class="px-0 font-weight-medium">
          <span>Hora Extra</span>
        </v-col>
        <v-col cols="3" sm="3" class="px-0">
          <span>{{ formatMoney(emp.hourAyco) }}</span>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="pt-10">
      <v-btn color="blue darken-1" text @click="onClose">Salir</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="onEnroll">Enrollar</v-btn>
      <v-btn color="blue darken-1" text @click="onEdit">Editar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { formatMoney } from '@/services/utils.js'
export default {
  props: {
    emp: Object
  },
  created() {
    this.formatMoney = formatMoney
  },
  methods: {
    onClose() {
      this.$router.push('./')
    },
    onEdit() {
      this.$router.push(`edit/${this.emp._id}`)
    },
    onEnroll() {
      this.$router.push(`enroll/${this.emp._id}`)
    }
  }
}

</script>
